'use client';

import { useMemo } from 'react';
import Container from '@framework/di/Container';
import DIContextProvider from '@framework/di/DIContext';
import createContainer, { PageRenderingStateValue } from '@framework/di/createContainer';
import { ICookies } from '@framework/router/Next/cookie/ClientCookie';
import { IClientReqData } from '@framework/router/Next/headers/ClientReqData';
import { loadModules } from '@framework/di/loadModules';
import { clientContainerModules } from '@DI_CONFIGURATION_MODULES';

type TProps = {
  children: any,
  cookie: ICookies,
  headers: IClientReqData,
};

export default function DIContext({ children, ...rest }: TProps) {
  const container = useMemo<Container>(() => {
    const container = createContainer(PageRenderingStateValue.ClientSideRendering);

    loadModules(container, clientContainerModules(rest));

    return container;
  }, []);

  return (
    <DIContextProvider container={ container }>
      { children }
    </DIContextProvider>
  );
}
